import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import sabadLog from "../../assets/images/logo-sabadi.png";
import logo from "../../assets/images/raw-meat-with-spices-removebg-preview.png";
export default function SpecialBasketItems({ data }) {
  const [hover, setHover] = useState(false);

  return (
    <>
      {/* {hover ? ( */}
      {/* <div className="item hover" onMouseLeave={() => setHover(false)}>
          <Swiper
            className="innerSwiper"
            dir="rtl"
            modules={[Navigation]}
            navigation={true}
          >
            {data.items.map((value, index) => (
              <SwiperSlide key={`basket-items${index}`}>
                <div class="card">
                  <img src={value.cover_img} class="card-img-top" alt="" />
                  <div class="card-body">
                    <h5 class="card-title">{data.title}</h5>
                    <p class="card-text">
                      <div>عنوان : {value.title}</div>
                      <div>تعداد : {value.count} عدد</div>
                      <div>
                        قیمت با تخفیف :{" "}
                        {addCommas(
                          (value.price - value.discount) * value.count
                        )}{" "}
                        <subtitle>تومان</subtitle>
                      </div>
                      <div>
                        قیمت بدون تخفیف : {addCommas(value.price * value.count)}{" "}
                        <subtitle>تومان</subtitle>
                      </div>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <button type="button" className="btn show-modal-btn">
            مشاهده جزئیات
          </button>
        </div> */}
      {/* ) : ( */}
      <div
        className="item mt-5 mb-5"
        // onMouseEnter={() => setHover(true)}
      >
        <div class="card" style={{ height: "420px" }}>
          <img
            src={`http://sabadi.tatdemo.ir/${data.basket_supplier.path}`}
            className="card-img-top mt-3"
            style={{ borderRadius: "7px" }}
            alt=""
          />
          <div class="card-body">
            <h5 class="card-title">
              <div
                className="wrapped-text-title"
                style={{ height: "20px", width: "220px" }}
              >
                {data.basket_supplier.title}
              </div>
            </h5>
            <p class="card-text">
              <div className="wrapped-text" style={{ height: "48px" }}>
                محتویات سبد :{" "}
                {data.basket_items.map((val) => val.title).join("، ")}
              </div>
              <div className="d-flex justify-content-between">
                {data.basket_supplier.total_discount !== "0" ? (
                  <div
                    style={{
                      color: "#CB2222",
                      textAlign: "center",
                      textDecorationLine: "line-through",
                    }}
                  >
                    {/* {addCommas(
                    data.basket_items.reduce(
                      (total, val) => total + val.price * val.count,
                      0
                    )
                  )} */}
                    {addCommas(data.basket_supplier.total_price)}
                  </div>
                ) : (
                  <div></div>
                )}

                <h6 className="text-center text-success">
                  {/* {addCommas(
                    data.basket_items.reduce(
                      (total, val) => total + val.price * val.count,
                      0
                    ) - data.basket_supplier.total_discount
                  )} */}
                  {addCommas(
                    +data.basket_supplier.total_price -
                      +data.basket_supplier.total_discount
                  )}
                  تومان
                </h6>
              </div>
            </p>
            <div style={{ height: "50px" }}>
              {data.basket_supplier.supplier_info && (
                <div
                  className="d-flex align-items-center justify-content-around p-1 mb-2"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "7px",
                  }}
                >
                  {data.basket_supplier.supplier_info.path ? (
                    <img
                      src={`http://sabadi.tatdemo.ir/${data.basket_supplier.supplier_info.path}`}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <img
                      src={sabadLog}
                      style={{ width: "40px", height: "30px" }}
                    />
                  )}
                  <h6 className="fs-12 mx-2 mt-1">
                    {data.basket_supplier.supplier_info.title}
                  </h6>
                </div>
              )}
            </div>
            <div className=" mb-3">
              <button
                type="button"
                className="btn show-modal-btn cursor-pointer px-4"
              >
                مشاهده جزئیات
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
